import React, { useEffect, useRef, useState } from 'react';
import { Buttton, Cards, Inputs } from '../components';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Commons } from '../utilities';
import { createSignalRConnection, getSignalRConnection } from '../services';
import { FaPaperclip } from 'react-icons/fa';

const ChatWindows = ({ chat, loginData, userType, displayName, fetchChatHistoryAction }) => {
    const { t } = useTranslation();
    const scrollRef = useRef(null);
    const dispatch = useDispatch();

    const [liveMessages, setLiveMessages] = useState([]);
    const [message, setMessage] = useState("");

    const [credentials, setCredentials] = useState({
        appointmentGuid: "",
        DoctorGuid: "",
        Currency: "",
        RequestTimeZone: "",
        PatientGuid: "",
        IsChatHistory: true,
        LanguageId: 1,
    });

    const postGetChatHistoryData = useSelector(
        (state) => state.doctor.postGetChatHistoryData?.data
    );

    useEffect(() => {
        if (loginData?.userGuid) {
            setCredentials((prev) => ({
                ...prev,
                DoctorGuid: loginData.userType === 1 ? loginData.userGuid : chat?.doctorGuid,
                PatientGuid: loginData.userType === 2 ? loginData.userGuid : chat?.patientGuid,
                Currency: loginData.currencyCode || "EUR",
                RequestTimeZone: loginData.timeZoneId,
                LanguageId: loginData.languageId,
                appointmentGuid: chat?.appointmentGuid,
            }));
        }
    }, [loginData, chat]);
    useEffect(() => {
        const { appointmentGuid, DoctorGuid, PatientGuid } = credentials;
        if (appointmentGuid && DoctorGuid && PatientGuid) {
            dispatch(fetchChatHistoryAction(credentials));
        }
    }, [credentials, dispatch, fetchChatHistoryAction]);
    useEffect(() => {
        if (postGetChatHistoryData?.result?.chatHistory) {
            setLiveMessages(postGetChatHistoryData?.result?.chatHistory);
        }
    }, [postGetChatHistoryData]);

    useEffect(() => {
        const connection = createSignalRConnection();

        connection.start()
            .then(() => console.log("SignalR connected ............"))
            .catch((err) => console.error("SignalR connect error:", err));

        connection.on("ReceiveMessage", (userGuid, messageText, appointmentGuid, senderUserType) => {
            console.log("userGuid", userGuid);
            console.log("messageText", messageText);
            console.log("appointmentGuid", appointmentGuid);
            console.log("senderUserType", senderUserType);

            const receiveMessage = {
                doctorGuid: chat?.doctorGuid,
                patientGuid: chat?.patientGuid,
                appointmentGuid,
                userType: senderUserType,
                message: messageText,
                doctorImageUrl: "",
                patientImageUrl: "",
                isChatHistory: true,
                createdDate: new Date().toISOString(),
            };

            console.log("receiveMessage", receiveMessage);


            setLiveMessages((prev) => [...prev, receiveMessage]);
        });

        return () => {
            connection.off("ReceiveMessage");
        };
    }, [chat?.appointmentGuid, chat?.doctorGuid, chat?.patientGuid]);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [liveMessages]);


    const handleSendMessage = () => {
        const connection = getSignalRConnection();
        if (connection && message.trim()) {
            const payload = {
                appointmentGuid: chat.appointmentGuid,
                doctorGuid: chat?.doctorGuid,
                patientGuid: chat.patientGuid,
                userType: loginData.userType,
                message: message.trim(),
                doctorImageUrl: "",
                patientImageUrl: "",
                isChatHistory: true,
                createdDate: new Date().toISOString(),
            };
            connection.invoke("SendMessage", loginData.userGuid, message, chat.appointmentGuid)
                .then(() => {
                    setLiveMessages((prev) => [...prev, payload]);
                    setMessage("");
                })
                .catch((err) => console.error("SendMessage error:", err));
        }
    };


    return (
        <Cards.Cardd
            header={
                <h5 className="exado-title-seven card-header-text">
                    {`${t("chat_with")} ${displayName}`}
                </h5>
            }
            content={
                <div className="chat-scroll-container" ref={scrollRef}>
                    {liveMessages.map((item, idx) => (

                        <div className={item.userType === userType ? "doctor-message" : "patient-message"} key={idx}>
                            <div className="usericon exado_body_text_two">
                                {item.userType === 1 ? "D" : "P"}
                            </div>
                            <div className="show-message-txt">
                                <div className="show-message-date exado-title-seven">{Commons.formatDate(item.createdDate)}</div>
                                <p className="show-message-text exado-title-seven">
                                    {item.message}
                                </p>
                            </div>
                        </div>

                    ))}
                </div>
            }
            footer={
                <>
                    <div className="blkIcon">{userType === 1 ? "D" : "P"}</div>
                    <div className="position-relative flex-grow-1">
                        <Inputs.FormInputs
                            name="message"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder="Write text here"
                            grpClassname={`form-group chat-input`}
                        // disabled={!isEditVisible}
                        />
                        <FaPaperclip className="position-absolute top-50  translate-middle-y paper-clip-icon custom-cursor-pointer" />
                    </div>

                    <Buttton.Buttton
                        className="btn-solid-Aqua_Teal"
                        children={t("SEND")}
                        onClick={handleSendMessage}
                    />
                </>
            }
            className="cardd cwp-card chat-card"
        />
    )
}

export default ChatWindows;
